import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'input' ]

  toggle(event) {
    this.inputTargets.forEach(inputTarget => {
      if (event.target.value === 'true') {
        inputTarget.originalValue = inputTarget.value
        inputTarget.type = 'date'

        if (inputTarget.originalValue) {
          inputTarget.value = inputTarget.originalValue.split('T')[0]
        }
      } else {
        const currentOriginalValue = inputTarget.value
        inputTarget.type = 'datetime-local'

        if (currentOriginalValue) {
          const time = inputTarget.originalValue ? inputTarget.originalValue.split('T')[1] : '09:00'
          inputTarget.value = `${currentOriginalValue}T${time}`
        }
      }
    })
  }
}
